import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { STOCK_HISTORY_FEATURE_KEY } from './keys';
import { stockHistoryReducer } from './reducers/stock-history.reducer';
import { StockHistoryEffects } from './effects/stock-history.effects';

export function provideStockHistoryStore(): EnvironmentProviders[] {
    return [provideState(STOCK_HISTORY_FEATURE_KEY, stockHistoryReducer), provideEffects(StockHistoryEffects)];
}
